/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-23 15:49:53
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2023-11-07 11:54:07
 * @FilePath: /mmtv2-frontend-pc/packages/main/src/permission.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import router from "./router";
const whiteList = [
  "/login",
  "/findpwd",
  "/h5login",
  "/bigScreen",
  "/bigscreen",
  "/bigScreenShopActivityRate",
  "/h5/trace-source/pdd/add",
  "/h5/trace-source/member/add",
  "/h5/trace-source/member/live",
  "/agreement",
  "/h5/update-price/login",
  "/h5/update-price/list",
  "/h5/update-price/success",
];
router.beforeEach((to, from, next) => {
  const hasToken = window.localStorage.getItem("token");
  if (hasToken) {
    if (to.path === "/login") {
      next({ path: "/login" });
      localStorage.clear();
    } else {
      next();
    }
  } else {
    if (to.path.includes("/h5/update-price")) {
      //记住密码，不能清空缓存
      if (to.path.includes("/h5/update-price/login")) {
        next();
      } else {
        if (to.query.goodsId) {
          let goodsId: any = to.query.goodsId || "";
          localStorage.setItem("h5_goodsId", goodsId);
          next({ path: "/h5/update-price/login" });
        }
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else {
        next({ path: "/login" });
      }
      localStorage.clear();
    }
  }
});
